export const environment = {
  production: true,
  showBranchBanner: true,
  adminUrl: `https://staging.app.timetailor.com`,
  apiUrl: 'https://staging.api.timetailor.com/booking/',
  version: '5c79e48d6a6b664fddaeae4a282ae6b9eb579098',
  defaultLocationUuid: '700c5ebe-db11-4655-a5ec-ed7b8eb6e9a5',
  stripePublishableKey:
    'pk_test_51S1QfpCkybO5Bra1RrVqP3v0nKZR3b7ndWkGGHrU8RAqH2VTsHdCPjh1pZ4E2fWdjU6H8nQP2kFUaomOnCmBSSz100fhGyivUw',
  i18nUrl: 'https://translations.timetailor.com/staging/widget/',
  i18nDebug: false,
  envName: 'staging',
};
